export default __webpack_public_path__ + "static/media/challenge-create.4fb551f1.md";